module.exports = __webpack_public_path__ + "static/media/on.31ef7d55.png";